<template>
  <v-container fluid class="supplier">
    <div class="hero-section">
      <v-container class="pa-0">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="d-flex flex-column justify-center px-5"
          >
            <h1 class="white--text">
              {{ header }}
            </h1>
            <p class="white--text my-5" v-html="subHeader"></p>
            <div class="mt-5">
              <v-btn
                color="appRed"
                class="white--text"
                v-scroll-to="{
                  element: '#signUp',
                  easing: 'linear',
                  onDone: onDone
                }"
                >SIGN UP</v-btn
              >
            </div>
          </v-col>
          <v-col sm="6" class="py-0" v-if="$vuetify.breakpoint.smAndUp">
            <img src="@/assets/hero.svg" class="hero-img" />
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-container>
      <v-row>
        <div class="business">
          <img src="@/assets/business.png" />
          <div class="business-text">
            <p class="gotham-medium">{{ signupHeader }}</p>
            <p class="gotham-medium"><span v-html="subHeader"></span></p>
          </div>
        </div>
      </v-row>
      <v-row class="px-110">
        <v-col
          cols="12"
          sm="4"
          class="d-flex flex-column align-center"
          v-for="point in uniqueSellingPoints"
          :key="point.header"
        >
          <div>
            <img :src="require(`@/assets/${point.icon}`)" />
          </div>
          <h2 class="py-5 gotham-light">{{ point.header }}</h2>
          <p class="text-center gotham-book" v-html="point.content"></p>
        </v-col>
      </v-row>
    </v-container>

    <div
      :class="getClass(index)"
      v-for="(feature, index) in features"
      :key="index"
    >
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" v-if="!everyOther(index)">
            <img :src="feature.img" class="w-100" />
          </v-col>
          <v-spacer v-if="!everyOther" />
          <v-col cols="12" sm="5">
            <h1 class="gotham-medium">
              {{ feature.header }}
            </h1>
            <p class="mt-5 gotham-book">
              {{ feature.text }}
            </p>
          </v-col>
          <v-spacer v-if="everyOther(index)" v-spacer></v-spacer>
          <v-col v-if="everyOther(index)" cols="12" sm="6">
            <img :src="feature.img" class="w-100" />
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="manage_sales bg-light-gray" id="signUp">
      <v-container>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6">
            <h2 class="text-center font-16 gotham-medium">
              {{ signupHeader }}
            </h2>
            <h1 class="text-center font-25 gotham-medium mt-3">
              {{ signupSubHeader }}
            </h1>
            <signup-form ref="signUp" />
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import SignupForm from "@/components/Shared/SalesPage/SignupForm.vue";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);
export default {
  name: "SalesPage",
  components: {
    SignupForm
  },
  data: () => ({}),
  computed: {
    state() {
      return this.$route.name.toLowerCase();
    },
    uniqueSellingPoints() {
      return this.$store.state[this.state].uniqueSellingPoints;
    },
    features() {
      return this.$store.state[this.state].features;
    },
    header() {
      return this.$store.state[this.state].header;
    },
    subHeader() {
      return this.$store.state[this.state].subHeader;
    },
    signupHeader() {
      return this.$store.state[this.state].signupHeader;
    },
    signupSubHeader() {
      return this.$store.state[this.state].signupSubHeader;
    }
  },
  methods: {
    onDone() {
      this.$refs.signUp.$refs.firstName.$refs.input.focus();
    },
    getClass(index) {
      return index % 2 === 0 ? "manage_sales bg-light-gray" : "manage_sales";
    },
    everyOther(index) {
      return index % 2 === 0;
    }
  }
};
</script>
<style scoped lang="scss" src="./SalesPage.scss"></style>
